import React from 'react'
import InforIntro from './InforIntro'
import InforServices from './InforServices'
import AboutUsInfor from './AboutUsInfor'
import Clients from './Clients'
import ServiceOfferings from './ServiceOfferings'
import InforCapabilities from './InforCapabilities'
import ContactForm from '../../ContactForm/ContactUs'
import { Helmet } from 'react-helmet';
import IndustrySolutions from './IndustrySolutions'

const InforPage = () => {
  return (
    <>
      <Helmet>
        <title>PT KCS | Infor ERP Consulting & Solutions Indonesia – Strategy to Implementation</title>
        <meta
          name="description"
          content="PT KCS offers expert Infor ERP consulting and full-lifecycle implementation in Indonesia, covering Infor LN, M3, CSI, OS, and Warehouse Management for complete digital transformation."
        />
        <meta
          name="keywords"
          content="PT KCS, PT KCS Indonesia, Infor ERP consulting Jakarta, Infor LN implementation Indonesia, Infor M3 solutions, Infor CSI ERP, Infor OS consulting, warehouse management Infor Indonesia, Infor supply chain planning, ERP digital transformation Indonesia"
        />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content="PT KCS | Infor ERP Consulting & Solutions Indonesia" />
        <meta
          property="og:description"
          content="PT KCS offers expert Infor ERP consulting and implementation in Indonesia. Covering Infor LN, M3, CSI, OS, and Warehouse Management for full digital transformation."
        />
        <meta property="og:image" content="https://ik.imagekit.io/kqumni8l2/INFOR_SERVICES_IMAGES/infographic2.png?updatedAt=1760003585804" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="PT KCS | Infor ERP Consulting & Solutions Indonesia" />
        <meta
          name="twitter:description"
          content="PT KCS offers expert Infor ERP consulting and implementation in Indonesia. Covering Infor LN, M3, CSI, OS, and Warehouse Management for full digital transformation."
        />
        <meta name="twitter:image" content="https://ik.imagekit.io/kqumni8l2/INFOR_SERVICES_IMAGES/infographic2.png?updatedAt=1760003585804" />

        {/* Additional SEO Tags */}
        <meta name="robots" content="index, follow" />
        <meta name="language" content="English" />
        <meta name="author" content="PT KCS" />
      </Helmet>
    <div className="font-satoshi"> 
       <div className="w-full overflow-hidden">
        <img
          src="https://ik.imagekit.io/kqumni8l2/INFOR_SERVICES_IMAGES/finall%202222%20(1).gif?updatedAt=1759993770253"
          alt="Animation"
          className="w-full max-w-full h-auto sm:h-40 md:h-60 lg:h-auto object-cover mx-auto"
        />
      </div>
      



      <InforCapabilities />
      <ServiceOfferings />
      <IndustrySolutions />
            <Clients />
      {/* <AboutUsInfor/>
      <InforServices /> */}
      
      <div id="infor-contact" className="scroll-mt-24">
        <ContactForm />
      </div>
    </div>
    </>
  )
}

export default InforPage
